const T4Custom = window.T4Custom || {};
T4Custom.initSwatchATC = (wrapper = null) => {
  const $document = $(document),
    cartAddUrl = T4Sroutes.cart_add_url + ".js";
  var classes = {
      loading: "is--loading",
    },
    aria = {
      disabled: "aria-disabled",
    };
  const swatchs = wrapper
    ? wrapper.querySelectorAll(".custom-size input:not(.t4-swatch-init)")
    : document.querySelectorAll(".custom-size input:not(.t4-swatch-init)");
  if (swatchs.length) {
    swatchs.forEach((swatch) => {
      swatch.classList.add("t4-swatch-init");
      swatch.addEventListener("click", (e) => {
        e.preventDefault();
        const $this = $(this);
        const _this = e.target,
          size = _this.value;
        const wrapper = _this.closest(".t4s-product-wrapper");
        if (!wrapper) return;
        const variants_wrapper = wrapper.querySelector("[data-pr-card-variants]");
        const label = $(wrapper).find("custom-size");
        const colorWrapper = $(wrapper).find(".t4s-pr-color__item.is-swatch--selected").length
          ? $(wrapper).find(".t4s-pr-color__item.is-swatch--selected")
          : $(wrapper).find(".t4s-pr-color__item")[0];
        if (!variants_wrapper) return;
        let variants = null;
        try {
          variants = JSON.parse(variants_wrapper.innerHTML);
        } catch (e) {
          console.log("error");
        }

        if (!variants || !variants.length) return;
        variants = variants[0];

        if (true) {
          let selected_variant;
          if (variants[0].options.length === 1)
            selected_variant = variants.find((item) => item.option1 == size || item.option2 == size);
          else {
            const color = colorWrapper
              ? colorWrapper.data
                ? colorWrapper.data("color")
                : $(colorWrapper).data("color")
              : null;
            selected_variant = variants.find(
              (item) =>
                (item.option1.toLowerCase() == size.toLowerCase() &&
                  item.option2.toLowerCase() == color.toLowerCase()) ||
                (item.option2.toLowerCase() == size.toLowerCase() && item.option1.toLowerCase() == color.toLowerCase())
            );
          }

          if (!selected_variant) return;

          label.addClass(classes.loading).attr("aria-disabled", true);
          label.find(".loading-overlay__spinner").removeAttr("hidden");
          label.find(".t4s-svg-spinner").removeAttr("hidden");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";

          var vid = selected_variant.id,
            qty = 1,
            arr_items = [];
          arr_items.push({
            id: vid,
            quantity: qty,
          });

          config.body = JSON.stringify({
            items: arr_items,
            sections: "cart_data,mini_cart",
            sections_url: window.location.pathname,
          });

          // {"items":[{"id":32271115321483,"quantity":1}],"sections":"cart_data,mini_cart","sections_url":"/collections/all/products/skin-sweatpans"}

          $document.on("cart:updated", function (e) {
            label.removeClass(classes.loading).removeAttr(aria.disabled);
            label.find(".loading-overlay__spinner").attr("hidden", "");
            label.find(".t4s-svg-spinner").attr("hidden", "");
            // $this.find('.loading-overlay__spinner').addClass('t4s-dn');
            $document.off("cart:updated");
          });

          fetch(`${cartAddUrl}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                handleErrorMessage(response.description);
                $document.trigger("cart:updated");
                return;
              }
              // console.log(response)
              $document.trigger("add:cart:success").trigger("add:cart:upsell");
              T4SThemeSP.isATCSuccess = true;
              renderDataSection(response.sections);
            })
            .catch((e) => {
              $document.trigger("cart:updated");
              console.error(e);
            });
        }
      });
    });
  }
  function fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: `application/${type}` },
    };
  }
  function renderDataSection(sections) {
    // console.log(response)
    if (sections) {
      T4SThemeSP.Cart.renderContents(sections);
    } else {
      T4SThemeSP.Cart.getToFetch();
    }
  }
  function handleErrorMessage(errorMessage = false) {
    // console.log('handleErrorMessage');

    // this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    // this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    // this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage && !T4Sconfigs.disOnlyStock) {
      T4SThemeSP.Notices(errorMessage);
      //this.errorMessage.textContent = errorMessage;
    }
  }
};

jQuery_T4NT(document).ready(function ($) {
  T4Custom.initSwatchATC();
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{ variant.id }}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });

  document.querySelector(".t4s-newsletter__submit").addEventListener("click", function (event) {
    const checkbox = document.querySelector("input[data-agreemail-checkbox]");

    // Verifica si el checkbox no está marcado
    if (!checkbox.checked) {
      event.preventDefault(); // Evita que el formulario se envíe
      alert("Debe aceptar los términos y condiciones."); // Muestra el mensaje de alerta
      checkbox.focus(); // Opcional: enfoca el checkbox para que el usuario lo vea
    }
  });
});

document.querySelector(".t4s-newsletter__submit").addEventListener("click", function (event) {
  const checkbox = document.querySelector("input[data-agreemail-checkbox]");

  // Verifica si el checkbox no está marcado
  if (!checkbox.checked) {
    event.preventDefault(); // Evita que el formulario se envíe
    alert("Debe aceptar los términos y condiciones."); // Muestra el mensaje de alerta
    checkbox.focus(); // Opcional: enfoca el checkbox para que el usuario lo vea
  }
});
